import './basePath';
import 'ckeditor4';

// ckeditor gem の CKEditor 4.7.1 は full プリセットだったので、同じプラグインを使う
// 外部のスペルチェックサービスを使う scayt と wsc（4.22 で無くなった）、非推奨になった flash は外す
const PLUGINS = [
  'dialogui',
  'dialog',
  'about',
  'a11yhelp',
  'dialogadvtab',
  'basicstyles',
  'bidi',
  'blockquote',
  'button',
  'toolbar',
  'notification',
  'clipboard',
  'panelbutton',
  'panel',
  'floatpanel',
  'colorbutton',
  'colordialog',
  'templates',
  'menu',
  'contextmenu',
  'copyformatting',
  'div',
  'resize',
  'elementspath',
  'enterkey',
  'entities',
  'popup',
  'filebrowser',
  'find',
  'fakeobjects',
  'floatingspace',
  'listblock',
  'richcombo',
  'font',
  'forms',
  'format',
  'horizontalrule',
  'htmlwriter',
  'iframe',
  'wysiwygarea',
  'image',
  'indent',
  'indentblock',
  'indentlist',
  'smiley',
  'justify',
  'menubutton',
  'language',
  'link',
  'list',
  'liststyle',
  'magicline',
  'maximize',
  'newpage',
  'pagebreak',
  'pastetext',
  'pastefromword',
  'preview',
  'print',
  'removeformat',
  'save',
  'selectall',
  'showblocks',
  'showborders',
  'sourcearea',
  'specialchar',
  'stylescombo',
  'tab',
  'table',
  'tabletools',
  'tableselection',
  'undo',
];

const CONFIG = {
  // 設定は JS で渡すので、CKEDITOR_BASEPATH の config.js は読まない
  customConfig: '',
  // 4.22 は古いバージョンだと「安全ではない」とエディタに通知するが、4.23 以降は有償の LTS 版なので出さない
  versionCheck: false,
  language: 'ja',
  plugins: PLUGINS.join(','),
  // サーバーのファイルブラウザは使わない
  filebrowserBrowseUrl: '',
  filebrowserImageBrowseLinkUrl: '',
  filebrowserImageBrowseUrl: '',
  filebrowserImageUploadUrl: '/ckeditor/pictures',
  filebrowserUploadUrl: '/ckeditor/attachment_files',
  // 4.9 から既定が XHR になったが、ckeditor gem の受け口は 4.7.1 までの form 送信の応答しか返せない
  filebrowserUploadMethod: 'form',
  // 4.17 からクリップボードの画像を Base64 のまま本文に入れるが、本文の文字数の上限や列の大きさを超えるので、画像はアップロードで入れてもらう
  clipboard_handleImages: false,
  allowedContent: true,
  toolbar: [
    {
      name: 'document',
      groups: ['mode', 'document', 'doctools'],
      items: ['Source'],
    },
    { name: 'links', items: ['Link', 'Unlink'] },
    { name: 'insert', items: ['Image'] },
    {
      name: 'paragraph',
      groups: ['list', 'align', 'bidi'],
      items: [
        'NumberedList',
        'BulletedList',
        '-',
        'JustifyLeft',
        'JustifyCenter',
        'JustifyRight',
        'JustifyBlock',
      ],
    },
    '/',
    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
    { name: 'colors', items: ['TextColor', 'BGColor'] },
    {
      name: 'basicstyles',
      groups: ['basicstyles', 'cleanup'],
      items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'],
    },
  ],
};

export const replaceWithCKEditor = (element) =>
  CKEDITOR.replace(element, CONFIG);
